import React, { useState } from 'react';
import {
  Button,
  Header,
  Icon,
  Modal,
} from 'semantic-ui-react';
import axios from 'axios';

import { useError } from '../providers';

const DeleteCommand = ({ command, refresh }) => {
  const { showError } = useError();

  const [open, setOpen] = useState(false);

  const confirmDelete = async () => {
    const endpoint = '/api/custom/delete';
    const payload = {
        'command': command.command,
    };

    try {
      const { data } = await axios.post(
        endpoint,
        payload,
      );

      switch (data.status) {
        case 200: // Save was successful.
          setOpen(false);
          refresh();
          break;
        case 403: // Validation error
            showError(<center>
            <p>{data.response.message}</p>
            {Object.keys(data.response.errors).map(key =>
              <p>{data.response.errors[key]}</p>
            )}
          </center>);
          break;
        case 401: // Unauthorized; redirect to home.
            showError(<center>Unauthorized access.</center>, () => window.location.assign('/'));
          break;
        case 404: // Command not found
            showError(<center>{data.response.message}</center>, () => window.location.assign('/'));
          break;
        case 500: // Internal server
        default:  // Anything else
            showError(<center>An unknown error occured while trying to save your changes.</center>);
          break;
      }
    } catch(err) {
        showError(<center>An unknown error occured while trying to save your changes.</center>);
    }
  }

  return (
    <Modal
      onClose={() => { setOpen(false); refresh(); }}
      onOpen={() => setOpen(true)}
      open={open}
      closeOnDimmerClick={false}
      trigger={
        <Button icon>
          <Icon name='trash alternate' />
        </Button>
      }
    >
      <Header icon='warning sign' content={`Delete command "!${command.command}"`} />
      <Modal.Content>
        <p>Are you sure you want to delete this command? This action is not reversible!</p>
      </Modal.Content>
      <Modal.Actions>
        <Button color='red' onClick={confirmDelete}>
          <Icon name='remove' />Yes, I am sure, delete this command.
        </Button>
        <Button color='green' onClick={() => { setOpen(false); }}>
          <Icon name='checkmark' /> No, don't delete it
        </Button>
      </Modal.Actions>
    </Modal>
  )
};

export default DeleteCommand;
